/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CompanyResponsiblePersonConnection'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./CompanyResponsiblePersonConnection'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.CompanyResponsiblePerson = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.CompanyResponsiblePersonConnection);
  }
}(this, function(ApiClient, CompanyResponsiblePersonConnection) {
  'use strict';




  /**
   * The CompanyResponsiblePerson model module.
   * @module model/CompanyResponsiblePerson
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>CompanyResponsiblePerson</code>.
   * @alias module:model/CompanyResponsiblePerson
   * @class
   */
  var exports = function() {
    var _this = this;







  };

  /**
   * Constructs a <code>CompanyResponsiblePerson</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CompanyResponsiblePerson} obj Optional instance to populate.
   * @return {module:model/CompanyResponsiblePerson} The populated <code>CompanyResponsiblePerson</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('BirthDate')) {
        obj['BirthDate'] = ApiClient.convertToType(data['BirthDate'], 'Date');
      }
      if (data.hasOwnProperty('Connections')) {
        obj['Connections'] = ApiClient.convertToType(data['Connections'], [CompanyResponsiblePersonConnection]);
      }
      if (data.hasOwnProperty('FirstNames')) {
        obj['FirstNames'] = ApiClient.convertToType(data['FirstNames'], 'String');
      }
      if (data.hasOwnProperty('LastName')) {
        obj['LastName'] = ApiClient.convertToType(data['LastName'], 'String');
      }
      if (data.hasOwnProperty('PersonalIdentificationCode')) {
        obj['PersonalIdentificationCode'] = ApiClient.convertToType(data['PersonalIdentificationCode'], 'String');
      }
      if (data.hasOwnProperty('Roles')) {
        obj['Roles'] = ApiClient.convertToType(data['Roles'], ['String']);
      }
    }
    return obj;
  }

  /**
   * @member {Date} BirthDate
   */
  exports.prototype['BirthDate'] = undefined;
  /**
   * @member {Array.<module:model/CompanyResponsiblePersonConnection>} Connections
   */
  exports.prototype['Connections'] = undefined;
  /**
   * @member {String} FirstNames
   * @default ''
   */
  exports.prototype['FirstNames'] = '';
  /**
   * @member {String} LastName
   * @default ''
   */
  exports.prototype['LastName'] = '';
  /**
   * @member {String} PersonalIdentificationCode
   * @default ''
   */
  exports.prototype['PersonalIdentificationCode'] = '';
  /**
   * @member {Array.<String>} Roles
   */
  exports.prototype['Roles'] = undefined;



  return exports;
}));


